import { BadgeCheck, Clock, ShieldQuestion } from "lucide-react";

const MAP = {
  owner_verified: { label: "Verificado por dueño", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: BadgeCheck },
  agent_verified: { label: "Verificado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: BadgeCheck },
  unverified: { label: "Sin verificar", cls: "bg-amber-50 text-amber-700 border-amber-200", icon: ShieldQuestion },
};

export const VerificationBadge = ({ status, className = "" }) => {
  const m = MAP[status] || MAP.unverified;
  const Icon = m.icon;
  return (
    <span
      data-testid="verification-badge"
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${m.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {m.label}
    </span>
  );
};

export const HoursPill = ({ hours }) =>
  hours ? (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
      <Clock className="h-3.5 w-3.5" /> {hours}
    </span>
  ) : null;
